import ZkAutocomplete from './src/autocomplete'

/* istanbul ignore next */
ZkAutocomplete.install = function(Vue) {
  Vue.component(ZkAutocomplete.name, ZkAutocomplete)
}

export default ZkAutocomplete



// WEBPACK FOOTER //
// ./src/packages/autocomplete/index.js